import { CONTENT_TYPES } from '@hivebrite/design-system/ContentList';

export const RESULTS_LIMIT = 3;
export const MIN_SCORE_THRESHOLD = 0.3;
export const AVAILABLE_CONTENT_TYPES = {
  NEWS: CONTENT_TYPES.NEWS,
} as const;
